import Callout from './Callout'
import Steps from './Steps'
import Keys from './Keys'
import MdxLink from './MdxLink'

export { Callout, Steps, Keys, MdxLink }

// Passed to <MDXProvider> in Layout.tsx so MDX files can use these components
// without an explicit import in every file. The `a` override makes plain
// markdown links use react-router for internal paths.
export const mdxComponents = {
  Callout,
  Steps,
  Keys,
  a: MdxLink,
}
